import React, { useState } from 'react'
import MuiAlert from '@mui/material/Alert';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';

const Alert = React.forwardRef<HTMLDivElement>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

export interface SnackBarDisplayProps {
    displayMs?: number;
    anchorOrigin?: SnackbarOrigin;
}

export const useSnackBarDisplay: () => [(props: SnackBarDisplayProps) => JSX.Element, (message: string, isError?: boolean) => void] = () => {
    const [userMessage, setUserMessage] = useState({ show: false, isError: false, message: '' });
    return [
        ({ displayMs = 3000, anchorOrigin = {vertical: 'top', horizontal: 'center'} }: SnackBarDisplayProps) =>
            <Snackbar anchorOrigin={anchorOrigin} open={userMessage.show} autoHideDuration={displayMs} onClose={() => setUserMessage({ show: false, isError: false, message: '' })}>
                {/* @ts-ignore */}
                <Alert onClose={() => setUserMessage({ show: false, isError: false, message: '' })} severity={userMessage.isError ? "error" : "success"} >{userMessage.message}</Alert>
            </Snackbar>,
        (message, isError = false) => setUserMessage({ show: true, isError: isError, message: message })
    ];
};